import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: '.app-affiliate-listing',
  templateUrl: './affiliate-listing.component.html',
  styleUrls: ['./affiliate-listing.component.scss']
})


export class AffiliateListingComponent implements OnInit {

  @Input() chooseMultiple: boolean;
  @Input() amazonOrSnapdeal: string;
  @Input()
  set storyId(storyId_string: number) {
    this.story_Id = (storyId_string) ? storyId_string : null;
  }

  @Input() set isCroma(is_Croma_boolean:boolean){
    this.is_Croma = (is_Croma_boolean)?is_Croma_boolean:null;
  }

  @Input()
  set exclusionList(exclusionList: any[]) {
    // console.log(exclusionList);
    this.storyIdList = (exclusionList && (exclusionList.length > 0)) ? exclusionList : [];
  }
  @Output() sendIdListToParentfn = new EventEmitter<any>();
  @Output() closePopupEmit = new EventEmitter<any>();
  @Output() openAmazonPopupEmit = new EventEmitter<any>();

  storyIdList = [];
  story_Id: number;
  is_Croma:boolean;
  constructor() {
    // console.log('related listing constructor');
  }

  ngOnInit() {
    // console.log('related story init' + this.story_Id);
  }

  storiesSelected() {
    this.openAmazonPopupEmit.emit(null);
    this.sendIdListToParentfn.emit(this.storyIdList);
  }

  storySelected(ev) {
    console.log(ev)
    if (ev.type === 'multiple') {
      const removeIndex = this.storyIdList.findIndex(item => item.value === ev.data.itemId);
      // remove object

      if (removeIndex == -1) {
        this.storyIdList.push({ key: ev.data.itemName ? ev.data.itemName : ev.data.productName, value: ev.data.itemId ,isPresent:true,checked:'true'});
      } else {
        this.storyIdList.splice(removeIndex, 1);
      }
    } else if (ev.type === 'single') {
      this.storyIdList.push(ev);
      // console.log('came here');
      this.sendIdListToParentfn.emit(ev.id);
    } else if (ev.type === 'singleSelectDone')
    {
      this.storyIdList.push(ev);
      this.sendIdListToParentfn.emit(this.storyIdList);
    }
    console.log('this.storyIdList', this.storyIdList)
  }

  closePopup() {
    this.closePopupEmit.emit(null);
  }

}